/* eslint-disable */
import i18next from 'i18next';

i18next.addResources('es', 'stageProgress', {
  finalInvestment: 'Inversión Final',
  originalInvestment: 'Inversión Original'
});

i18next.addResources('en', 'stageProgress', {
  finalInvestment: 'Final Investment',
  originalInvestment: 'Original Investment'
});

i18next.addResources('pt', 'stageProgress', {
  finalInvestment: 'Investimento Final',
  originalInvestment: 'Investimento Original'
});
